import { styled } from "@mui/material/styles";
import ToggleButton from "@mui/material/ToggleButton";

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
    color: "gray",
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: "20px",
    "&.Mui-selected": {
        color: "white",
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
    },
    "&.Mui-selected:hover": {
        backgroundColor: theme.palette.primary.dark,
    },
    "&:hover": {
        backgroundColor: theme.palette.action.hover,
    },
    "@media (hover: none)": {
        "&:hover": {
            backgroundColor: "inherit",
        },
        "&.Mui-selected:hover": {
            backgroundColor: theme.palette.primary.main,
        },
    },
}));

export default CustomToggleButton;
